import React from 'react';
import styles from './styles.sass';

const Spinner = ({ size = 40, color = 'white', style = {} }) => (
  <div
    className={`${styles.spinner} ${styles[color]}`}
    style={{
      height: `${size}px`,
      width: `${size}px`,
      ...style,
    }}
  >
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);

export const CenteredSpinner = props => (
  <div className={styles.centered}>
    <Spinner {...props} />
  </div>
);

export default Spinner;
